import * as React from "react";
import { useCallback } from "react";
import RuleOptionsForm from "security-app/components/SigmaRules/RuleOptionsForm";
import { hasError } from "../utils";
import { FormContainer, FileNameTitle, StyledAlert } from "../styled-components";
function FileOptionsForm({ selectedFile, setSelectedFile, setFiles, formState }) {
  const isZip = selectedFile.file.type === "application/zip";
  const onOptionsChange = useCallback(
    (newOptions) => {
      setSelectedFile((prevFile) => ({ ...prevFile, ...newOptions }));
      setFiles(
        (prevFiles) => prevFiles.map((prevFile) => {
          if (prevFile.id === selectedFile.id) return { ...prevFile, ...newOptions };
          return prevFile;
        })
      );
    },
    [setSelectedFile, setFiles, selectedFile.id]
  );
  return /* @__PURE__ */ React.createElement(FormContainer, null, /* @__PURE__ */ React.createElement(FileNameTitle, null, selectedFile.file.name), /* @__PURE__ */ React.createElement(
    RuleOptionsForm,
    {
      formId: selectedFile.id,
      initialValues: selectedFile,
      onSubmit: onOptionsChange,
      formState,
      autoSubmit: true,
      isTemporal: !isZip && selectedFile.ruleValidation.is_temporal
    }
  ), isZip && !hasError(selectedFile) && /* @__PURE__ */ React.createElement(StyledAlert, { bsStyle: "info", "aria-label": "ZIP files info message" }, /* @__PURE__ */ React.createElement("p", null, "All rules included in the ZIP file will share the same settings")));
}
export default FileOptionsForm;
